import classNames from 'classnames';
import React from 'react';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { bsTiny } from '../../helpers/ui.helper';
import { useMembership, useUser } from '../../hooks/users';
import PaymentPage from '../User/PaymentPage';

const OverlayContainer = styled.div`
  position: relative;
  .require-vip-overlay {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
  }
  &:hover .require-vip-overlay,
  .require-vip-overlay.always {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .overlay-msg {
      font-size: 0.8rem;
      margin-right: 0.5rem;
    }
  }
`;

interface Props {
  children?: React.ReactNode;
  featureTitle: string;
  message?: string;
  always?: boolean;
}

const FeatureRequiresVIPOverlay: React.FC<Props> = ({
  children,
  featureTitle,
  message = null,
  always = false,
}) => {
  const user = useUser();
  const hasMembership = useMembership();

  const [show, setShow] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      {hasMembership && children}
      {!hasMembership && (
        <OverlayContainer>
          {children}
          <div className={classNames('require-vip-overlay', { always })}>
            <span className="overlay-msg">
              {message || t('feature-requires-vip')}
            </span>
            <Button
              size={bsTiny}
              variant="primary"
              onClick={() => setShow(true)}
            >
              {t('know-more')}
            </Button>
          </div>
          <Modal show={show} size="xl" centered onHide={() => setShow(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{t('feature-requires-vip')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {t('you-need-to-pay-to-unlock')}
              <strong>{featureTitle}</strong>.
              <hr />
              {user && <PaymentPage />}
            </Modal.Body>
          </Modal>
        </OverlayContainer>
      )}
    </>
  );
};

export default FeatureRequiresVIPOverlay;
